const STORAGE_KEY = 'PAT_DEVICE_ID';

function generateUuid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    // RFC4122 v4 fallback for browsers without crypto.randomUUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

// A stable per-browser identifier, persisted across sessions/reloads in
// localStorage. Generated once on first load; reused thereafter.
function loadOrCreateDeviceId() {
    try {
        let id = window.localStorage.getItem(STORAGE_KEY);
        if (!id) {
            id = generateUuid();
            window.localStorage.setItem(STORAGE_KEY, id);
        }
        return id;
    } catch (e) {
        // localStorage unavailable (e.g. private browsing) — use an ephemeral id
        return generateUuid();
    }
}

const DeviceId = {
    DEVICE_ID: loadOrCreateDeviceId()
};

export default DeviceId;
